import React, { Component } from "react";
import { Route, Link } from "react-router-dom";
import Navbar from "../presentational/Navbar";
import { textToLink } from "../functions/textToLink";

class NavbarContainer extends Component {
  state = {
    expanded: false,
    menuItems: ["за нас", "корпоративно управление", "за инвеститори"]
  };

  toggleExpanded = () => {
    this.setState(prevState => ({ expanded: !prevState.expanded }));
  };

  render() {
    const { expanded, menuItems } = this.state;
    return (
      <Navbar expanded={expanded} toggleExpanded={this.toggleExpanded}>
        {menuItems.map(en => {
          const text = en;
          const to = textToLink(`/${en}`);
          return (
            <Route
              key={to}
              path={to}
              children={({ match }) => (
                <Link to={to} className={`navbar-item transitioned${match ? ` is-active` : ``}`}>
                  <span>{text}</span>
                </Link>
              )}
            />
          );
        })}
      </Navbar>
    );
  }
}

export default NavbarContainer;



// WEBPACK FOOTER //
// ./src/containers/Navbar.js